export default __webpack_public_path__ + "static/media/night.c40e070b.mp3";